import React from "react";
import Header from "../common/Header";
import BackgroundVideo from "../common/BackgroundVideo";
import OutlookMiddleHeader from "./OutlookMiddleHeader";
import OutlookSidebar from "./OutlookSidebar";
import stepImg1 from "../assets/images/ss-1.png";
import stepImg2 from "../assets/images/ss-2.png";
import stepImg3 from "../assets/images/ss-3.png";
import stepImg4 from "../assets/images/ss-4.png";
import stepImg5 from "../assets/images/ss-5.png";
import stepImg6 from "../assets/images/ss-6.png";
import stepImg7 from "../assets/images/ss-7.png";
import xmlFile from "../assets/images/momentum-outlook-add-in.xml";
import AtkButton from "../AtlaskitControls/AtkButton";
import AtkButtonIconBefore from "../AtlaskitControls/AtkButtonIconBefore";
import DownloadIcon from "@atlaskit/icon/glyph/download";

export default function OutlookLandingPage() {
  const onDownloadClick = async () => {
    const response = await fetch(xmlFile);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "MomentumMail.xml";
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  const installationsteps = [
    {
      subtitle: "Log into your Office 365 email via Outlook (Web version recommended).",
      img: "",
    },
    {
      subtitle: "Open any email in your inbox.",
      img: "",
    },
    {
      subtitle: (
        <>
          On the right side of the email, click the Apps icon (four squares arranged in a square); or visit URL (
          <a href="https://aka.ms/olksideload" target="_blank" rel="noopener noreferrer">
            https://aka.ms/olksideload
          </a>
          ).
        </>
      ),
      img: "",
    },

    {
      subtitle: "Click the “Get Add-ins +” button — this will redirect you to the Add-ins menu.",
      img: stepImg1,
    },
    {
      subtitle: "In the Add-ins window, click on “My add-ins” in the left sidebar.",
      img: stepImg2,
    },
    {
      subtitle: "Scroll to the bottom and click “+ Add a custom add-in” > “Add from file…”",
      img: stepImg3,
    },
    {
      subtitle: (
        <>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              onDownloadClick();
            }}
          >
            Download
          </a>{" "}
          the custom .xml file (e.g. <code>MomentumMail.xml</code>).
        </>
      ),
      img: "",
    },

    {
      subtitle: "Click Install to complete the setup.",
      img: "",
    },
    {
      subtitle: "You’ll now see the Momentum Mail icon in your Outlook toolbar when viewing emails.",
      img: stepImg4,
    },
  ];

  const momentumsteps = [
    {
      subtitle: "Step 1: Launch the Add-In",
      details: [
        "Open any email in your inbox.",
        "Click the Apps icon (Four squares) on the right-hand side of the email.",
        "From the list of available apps, click on Momentum AMS.",
      ],
      img: stepImg5,
    },
    {
      subtitle: "Step 2: Log In",
      details: [
        "The app will prompt you to log in using your Momentum AMS credentials.",
        "Once logged in, you’ll see the main Momentum Mail interface.",
      ],
      img: stepImg6,
    },
    {
      subtitle: "Step 3: Navigating the Add-In",
      details: [
        <b>General Tab</b>,

        // "General Tab:",
        "Automatically searches for the Insured associated with the email.",
        "If no match is found, a “+” button will appear to add the sender as an Insured.",
        "You can search manually by name or email.",
        "Once selected, you can link policies, create tasks, and add internal notes.",

        <b>AI Assistant Tab</b>,
        "Scans your mailbox using AI to detect key email types (e.g. certificate requests, quote inquiries, etc.)",
        "Detected emails will trigger notifications inside both the add-in and your Momentum AMS dashboard.",
        "To enable this feature, you must grant permission by checking the box provided.",
      ],
      img: stepImg7,
    },
    {
      subtitle: "Step 4: Configure Settings",
      details: [
        "After granting permission, you’ll see the Settings tab",
        "Choose which types of emails you want the AI to recognize",
        " Enable Auto Task Creation – e.g., automatically create a task when a certificate request email is received",
        "Option to pause syncing anytime.",
      ],
    },
    {
      subtitle: "Step 5: View Notifications",
      details: [
        "In the Notifications tab, you’ll see a list of emails the AI has recognized",
        "Click any notification to view an AI-generated summary of the email.",
        " From this summary screen, you can also create a task instantly.",
      ],
    },
  ];
  return (
    <>
      <div className="naics-landing-main-page">
        <Header pagename="naics-landing-page" />
        <div className="content-wrapper ">
          <BackgroundVideo />
          <div className="row  wrapper-main-row mx-auto wrapper-below-div">
            <div className="col-12">
              <OutlookMiddleHeader />
            </div>
            <div className="row main-content-row mx-auto">
              <div className="col-lg-2 col-md-3 sidebar-col display-for-desktop">
                <OutlookSidebar pagename="outlook-page" />
              </div>
              <div className="col-lg-10 col-md-12 col-sm-12 main-content-col ">
                <div className="col-12 p-2 mt-3">
                  <div className="card  ">
                    <div className="card-body">
                      <div className="row  d-flex  align-items-center ">
                        <div className="col-6 ">
                          <b className="fs-5">How to Install the Momentum Mail Outlook Add-In</b>
                        </div>

                        <>
                          <div className="col-12">
                            <span className="text-16 ">
                              {" "}
                              Supercharge your Outlook with the Momentum Mail Add-In—designed to help your agency stay organized, communicate better,
                              and take advantage of built-in AI tools to streamline your workflow.
                            </span>
                          </div>
                          <div className="col-12 text-14 mt-1" style={{ textAlign: "justify" }}>
                            <ul className="list-unstyled mb-0">
                              <li className="mb-2">• Organize and tag emails to clients or policies.</li>
                              <li className="mb-2">• Attach files directly into Momentum.</li>
                              <li className="mb-2">• Create tasks and add internal notes.</li>
                              <li className="mb-2">• Use the built-in AI Agent to summarize email.</li>
                            </ul>
                          </div>
                        </>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row  p-2">
                  <div className="col-12 text-center">
                    <AtkButtonIconBefore
                      label="Download Outlook XML"
                      onClick={onDownloadClick}
                      iconBefore={<DownloadIcon label="" />}
                      className="pf-primary-btn w-auto me-1   my-1 "
                    />
                  </div>
                </div>

                <div className="row  p-2">
                  <div className="col-6">
                    <div className="card ">
                      <div className="card-body">
                        <div className="row">
                          <b className="mb-2 text-18 bg-light">✅ Installation Steps:</b>

                          <div className="form-group mb-2 text-14" style={{ height: "70vh", overflowY: "auto" }}>
                            {installationsteps.map((step, index) => (
                              <div key={index} className="mb-2 border-bottom pb-3 ">
                                <span>
                                  <span className="me-2 fw-bold">Step {index + 1}:</span>
                                  {step.subtitle}
                                </span>
                                <div className="d-block text-center">
                                  {step.img && <img src={step.img} alt="step" className="img-fluid mt-2 w-50 " />}
                                </div>{" "}
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="card ">
                      <div className="card-body">
                        <div className="row">
                          <b className="mb-2 text-18 bg-light">🚀 How to Use</b>

                          <div className="form-group mb-2 text-14" style={{ height: "70vh", overflowY: "auto" }}>
                            {momentumsteps.map((step, index) => (
                              <div key={index} className="mb-2 border-bottom pb-3 ">
                                <span className="fw-bold">{step.subtitle}</span>
                                <ul>
                                  {step.details.map((line, i) => (
                                    <li key={i}>{line}</li>
                                  ))}
                                </ul>
                                <div className="d-block text-center">
                                  {step.img && <img src={step.img} alt="step" className="img-fluid mt-2 w-50 " />}
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
